import React from 'react';
import { describe, PropTypes } from '@amzn/stencil-react-desc';
import { cssValue } from "../prop-types";
import { ScreenReaderOnly } from "../screen-reader-only";
import { Text } from "../text";
import { jsx as ___EmotionJSX } from "@emotion/core";
var AvatarTextBase = Text.withComponent('span', {
  target: "e1b9w7yl0"
});
AvatarTextBase.displayName = 'AvatarTextBase';
AvatarTextBase.propTypes = Text.propTypes;
AvatarTextBase.defaultProps = Text.defaultProps;

var AvatarText = function AvatarText(_ref) {
  var children = _ref.children,
      fontSize = _ref.fontSize,
      lineHeight = _ref.lineHeight,
      hiddenText = _ref.hiddenText;
  return ___EmotionJSX(React.Fragment, null, !!hiddenText && ___EmotionJSX(ScreenReaderOnly, null, hiddenText), ___EmotionJSX(AvatarTextBase, {
    display: "inline",
    fontSize: fontSize,
    lineHeight: lineHeight
  }, children));
};

AvatarText.displayName = 'AvatarText';
var AvatarTextWithDocs = describe(AvatarText).description('Used to display additional information about the employee.');
AvatarTextWithDocs.propTypes = {
  children: PropTypes.node.description('Text to be displayed in the additional info.').isRequired,
  fontSize: cssValue().description("Sets the CSS 'font-size' property for the text element."),
  lineHeight: cssValue().description("Sets the CSS 'line-height' property for the text element."),
  hiddenText: PropTypes.string.description('Sets the hidden label for the text.')
};
export default AvatarTextWithDocs;